import { render, staticRenderFns } from "./ImInputNumber.vue?vue&type=template&id=5defe688"
import script from "./ImInputNumber.vue?vue&type=script&lang=js"
export * from "./ImInputNumber.vue?vue&type=script&lang=js"
import style0 from "./ImInputNumber.vue?vue&type=style&index=0&id=5defe688&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports